import SearchBar from 'components/SearchBar/SearchBar';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { PermsContextType } from 'contexts/perms.types';
import { Button } from 'react-bootstrap';
interface Props {
  searchValue: string;
  onSearchChange: (nextValue: string) => void;
  rolesEmpty: boolean;
  perms: PermsContextType;
  hierarchyChanged: boolean;
  onSaveHierarchy: () => Promise<void> | void;
  onDiscardHierarchy: () => void;
}

export default function RolesHeader({
  searchValue,
  onSearchChange,
  rolesEmpty,
  perms,
  hierarchyChanged,
  onSaveHierarchy,
  onDiscardHierarchy,
}: Props) {
  return (
    <div className="w-100">
      <div className="w-100 w-lg-25 mb-2 justify-content-end ms-auto">
        <SearchBar
          className="bg-primary-highlight rounded-3"
          inputClassName=""
          disabled={false}
          value={searchValue}
          onChange={onSearchChange}
          includeClear
        />
      </div>
      {rolesEmpty && <WidgetLoadingAnimation widgetName={''} dimensions={'1x1'} disableText={true} />}
      {Number(perms.accessLevel ?? -1) >= 12 && hierarchyChanged && (
        <div className="d-flex flex-row mt-2">
          <Button
            className="p-2 rounded ms-3 justify-content-center align-items-center d-flex"
            onClick={async () => {
              void onSaveHierarchy();
            }}
          >
            <div>Save</div>
          </Button>
          <Button
            className="d-flex align-items-center justify-content-center p-2 rounded ms-3"
            onClick={() => {
              onDiscardHierarchy();
            }}
          >
            <div>Discard</div>
          </Button>
          <div className="ms-2 align-self-center">
            Careful! You have unsaved changes to the Organization's Role Hierarchy, this controls
            the highest-ranked role of all Client Users.
          </div>
        </div>
      )}
    </div>
  );
}
